(function () {
  const initSlider = (section) => {
    const slider = section.querySelector(".collection-list__inner");
    if (!slider || slider.swiper) return;

    const slides = slider.querySelectorAll(".collection-list__item");

    if (slides.length <= 2) return;

    slider.classList.add("swiper");

    const wrapper = document.createElement("div");
    wrapper.classList.add("swiper-wrapper");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
      wrapper.appendChild(slide);
    });

    slider.appendChild(wrapper);

    const nextBtn = section.querySelector(
      ".collection-list-banner-swiper__button--next"
    );
    const prevBtn = section.querySelector(
      ".collection-list-banner-swiper__button--prev"
    );
    const paginationEl = section.querySelector(
      ".collection-list-banner-swiper__pagination"
    );

    const slidesArray = Array.from(slides);
    const activeIndex = slidesArray.findIndex((slide) =>
      slide.classList.contains("current")
    );

    let breakpointsSettings = {
      spaceBetween: 20,
      slidesPerView: "auto",
    };

    new Swiper(slider, {
      slidesPerView: "auto",
      spaceBetween: 8,
      speed: 800,
      initialSlide: activeIndex > -1 ? activeIndex : 0,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationEl,
        clickable: true,
        type: "bullets",
      },
      breakpoints: {
        0: {
          slidesPerGroup: 2,
          spaceBetween: 8,
        },
        576: {
          ...breakpointsSettings,
          slidesPerGroup: 3,
        },
        748: {
          ...breakpointsSettings,
          slidesPerGroup: 4,
        },
        920: {
          ...breakpointsSettings,
          slidesPerGroup: 5,
        },
        1100: {
          ...breakpointsSettings,
          slidesPerGroup: 6,
        },
        1320: {
          ...breakpointsSettings,
          slidesPerGroup: 7,
        },
        1500: {
          ...breakpointsSettings,
          slidesPerGroup: 8,
        },
        1684: {
          ...breakpointsSettings,
          slidesPerGroup: 9,
        },
        1860: {
          ...breakpointsSettings,
          slidesPerGroup: 10,
        },
      },
    });
  };

  const initCollectionHero = (section) => {
    if (!section?.classList.contains("collection-header")) return;
    initSlider(section);
  };

  initCollectionHero(document.querySelector(".collection-header"));

  document.addEventListener("shopify:section:load", function (event) {
    initCollectionHero(event.target);
  });
})();
